import React from "react";
import { Link, useNavigate } from "react-router-dom";

function Header() {
    const navigate = useNavigate();
    navigate("users");

    return (

        <div className="full-width-header home8-style4 main-home">
            <header id="rs-header" className="rs-header">
                <div className="menu-area menu-sticky">
                    <div className="container">
                        <div className="row y-middle">
                            <div className="col-lg-2">
                                <div className="logo-cat-wrap">
                                    <div className="logo-part">
                                        <Link to="/">
                                            <img style={{ height: "90%", width: "90%", margin: "3px"}} className="normal-logo" src="assets/images/logo2.png" alt="" />
                                            <img style={{ height: "90%", width: "90%", margin: "3px"}} className="sticky-logo" src="assets/images/logo2.png" alt="" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-10 text-right">
                                <div className="rs-menu-area">
                                    <div className="main-menu">
                                        <div className="mobile-menu">
                                            <a className="rs-menu-toggle" href="javascript(void)">
                                                <i className="fa fa-bars"></i>
                                            </a>
                                        </div>
                                        <nav className="rs-menu">
                                            <ul className="nav-menu">
                                                <li className="rs-mega-menu mega-rs menu-item-has-children">                                                   
                                                    <Link to="/" onClick={() => navigate()}>About Us</Link >
                                                </li>                                                
                                                <li className="rs-mega-menu mega-rs menu-item-has-children">
                                                    <Link to="/givingopportunity" onClick={() => navigate()}>Giving Opportunities</Link >
                                                </li>
                                                <li className="rs-mega-menu mega-rs menu-item-has-children">
                                                    <Link to="/" onClick={() => navigate()}>Resources</Link >
                                                        <ul className="sub-menu">
                                                        <li><Link to="/gallery" onClick={() => navigate()}>Gallery</Link ></li>                                                        
                                                        <li><Link to="/newsletter" onClick={() => navigate()}>Newsletters</Link ></li>
                                                        {/* <li><Link to="/calendar" onClick={() => navigate()}>Calendar</Link ></li> */}
                                                        </ul>                                                    
                                                </li>
                                                {/* <li className="rs-mega-menu mega-rs menu-item-has-children">
                                                <Link to="/events" onClick={() => navigate()}>Events</Link >
                                                </li> */}
                                                <li className="rs-mega-menu mega-rs menu-item-has-children">
                                                    <Link to="/team" onClick={() => navigate()}>Team</Link >
                                                </li>
                                                <li className="rs-mega-menu mega-rs menu-item-has-children">
                                                    <Link to="/contact" onClick={() => navigate()}>Contact Us</Link >
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </div>
    );
}

export default Header;